<template>
  <transition appear
              name="fade">
    <div class="md:absolute md:inset-0 md:z-40 t3m-Modal t3m-Modal--default text-t3m-body !block"
         id="t3m-Modal--imageMap"
         aria-hidden="true">
      <div class="hidden rounded t3m-hide-for-print t3m-Backdrop from-white md:block md:rounded-lg"
           :class="{
             't3m-Backdrop--left': selectedHotspot.modalAlignment === 'left',
             't3m-Backdrop--right': selectedHotspot.modalAlignment === 'right'
           }"
           tabindex="-1"
           @click="setStatus('leave')"></div>
      <div class="relative h-full pointer-events-none">
        <div class="inset-y-0 p-8 mt-4 bg-gray-200 rounded md:absolute md:flex md:items-start md:justify-center md:w-1/2 t3m-Modal-overlay !animate-none md:bg-transparent md:rounded-lg md:mt-0"
             :class="{
               'left-0': selectedHotspot.modalAlignment === 'left',
               'right-0': selectedHotspot.modalAlignment === 'right'
             }">
          <div class="flex flex-col w-full bg-white rounded shadow-lg t3m-Modal-container max-h-screen-height-9/10 pointer-events-auto"
               role="dialog"
               aria-modal="true"
               aria-labelledby="t3m-Modal--{data.uid}-title">
            <header class="flex items-center justify-between p-6 t3m-Modal-header">

              <h4 class="my-0 t3m-Modal-title"
                  id="t3m-Modal--{data.uid}-title">{{ selectedHotspot.title }}</h4>

              <button type="button"
                      class="ml-auto t3m-Modal-close"
                      aria-label="Close modal"
                      @click="setStatus('leave')">
                <span aria-hidden="true">✕</span>
              </button>
            </header>

            <div class="px-6 pb-6 overflow-y-auto t3m-Modal-content">
              <div v-html="selectedHotspot.content"></div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "t3mModal",
  computed: {
    ...mapState(["selectedHotspot", "status"])
  },
  methods: {
    ...mapActions(["setStatus"])
  }
};
</script>

<style>
#t3m-Modal--imageMap ul {
  margin-top: 2rem;
  margin-bottom: 2rem;
  list-style-type: disc;
  padding-left: 1.5rem;
}

#t3m-Modal--imageMap ul > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

#t3m-Modal--imageMap ul > li::marker {
  color: var(--t3m-primary);
}

#t3m-Modal--imageMap ul ul {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

#t3m-Modal--imageMap ul ul > li::marker {
  color: var(--t3m-muted);
}
</style>
